import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import bp from 'Styles/breakpoints';
import { fontBody } from 'Styles/fonts';

export const MINI_SWATCH_HEIGHT = 21;
export const REGULAR_SWATCH_HEIGHT = 23;

export const ColorSelection = styled.div`
  background-color: transparent;
  box-sizing: content-box;
  min-height: ${MINI_SWATCH_HEIGHT - 6}px;
  padding-top: 12px;

  ${({ $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      min-height: ${REGULAR_SWATCH_HEIGHT * 1.33 - 2}px;
    }
  `}
`;

export const Swatch = styled.div`
  display: grid;
  position: relative;
  z-index: 100;
`;

export const Link = styled.a`
  ${fontBody(13)}
  line-height: 1;
  grid-column: span 1;
  text-decoration: none;
  color: var(--foreground);
  z-index: 1;

  ${({ isOpen, $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      ${fontBody(16)}
      line-height: 1;
    }

    ${bp('large', { mode: $styleQueryMode })} {
      ${isOpen && 'opacity: 0; display: none;'}
    }
  `}
`;

export const Dropdown = styled.div`
  align-items: center;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fill, ${MINI_SWATCH_HEIGHT}px);
  width: 100%;
  background-color: transparent;
  margin-top: 4px;
  margin-bottom: 4px;

  ${({ $styleQueryMode }) => css`
    ${bp('medium', { mode: $styleQueryMode })} {
      grid-template-columns: repeat(auto-fill, ${REGULAR_SWATCH_HEIGHT}px);
      margin-top: 0;
      margin-bottom: 0;
    }
  `}

  ${ifProp(
    '$showMoreLink',
    () => css`
      ${Swatch}:nth-child(n + 4) {
        opacity: 0;
        display: none;
      }
    `
  )}

  ${({ isOpen, $styleQueryMode }) => css`
    ${bp('large', { mode: $styleQueryMode })} {
      ${isOpen &&
      `${Swatch}:nth-child(n + 4) {
            opacity: 1;
            display: block;
          }
        `}
    }
  `}
`;
